export const DETAILS = {
  name: "Vaidhyanathan S M",
  logo: "assets/images/name.svg",
  profile_links: {
    email: {
      link: "vaidhyanathan.sm@gmail.com",
      image: "assets/images/gmail.svg",
    },
    github: {
      link: "https://github.com/smv1999",
      image: "assets/images/github.svg",
    },
    linkedin: {
      link: "https://www.linkedin.com/in/vaidhyanathansm/",
      image: "assets/images/linkedin.svg",
    },
    medium: {
      link: "https://vaidhyanathansm.medium.com/",
      image: "assets/images/medium.svg",
    },
    hackerrank: {
      link: "https://www.hackerrank.com/vaidhyanathan_sm?hr_r=1",
      image: "assets/images/hackerrank.svg",
    },
    geeksforgeeks: {
      link: "https://auth.geeksforgeeks.org/user/vaidhyanathansm/profile",
      image: "assets/images/geeksforgeeks.svg",
    },
  },
  profile_image: "assets/images/profile_image.jpg",
  about_me: {
    para1: "<Hello World/>",
    para2:
      "This is Vaidhyanathan S M. I am currently working as a Senior Product Engineer in Tata Consultancy Services for 3.5+ years.",
    para3:
      "I am a skilled Native Android and Flutter Developer with 9 apps successfully published on to the Google Play Store. I have the potential of converting ideas into working products. I am also highly skilled in C/C++, Java, Python, Angular, Spring Boot and Flask. I have special interests in the field of Artificial Intelligence and Data Science.",
    para4:
      "I also write Technical Articles during my free time on Medium. I am an active Open Source Contributor on GitHub.",
  },
  education: {
    college: {
      name: "Rajalakshmi Engineering College",
      course: "B.E Computer Science and Engineering",
      grade: "9.41",
      timeline: "2017-2021",
      image: "assets/images/college.jpg",
    },
    higher_secondary_school: {
      name: "Kendriya Vidyalaya",
      course: "Computer Science",
      grade: "95.2 %",
      timeline: "2016-2017",
      image: "assets/images/high_sec_school.jpg",
    },
    secondary_school: {
      name: "Kendriya Vidyalaya",
      grade: "9.6",
      timeline: "2014-2015",
      image: "assets/images/sec_school.jpeg",
    },
  },
  skills: [
    {
      image: "assets/images/android.svg",
      name: "Native Android",
    },
    {
      image: "assets/images/python.svg",
      name: "Python",
    },
    {
      image: "assets/images/c_lang.svg",
      name: "C",
    },

    {
      image: "assets/images/react.svg",
      name: "React",
    },
    {
      image: "assets/images/git.svg",
      name: "Git",
    },
    {
      image: "assets/images/mysql.svg",
      name: "MySQL",
    },
    {
      image: "assets/images/flutter.svg",
      name: "Flutter",
    },
    {
      image: "assets/images/linux.svg",
      name: "Linux",
    },
    {
      image: "assets/images/firebase.svg",
      name: "Firebase",
    },
    {
      image: "assets/images/blogging.jpg",
      name: "Technical Blogging",
    },
    {
      image: "assets/images/flask.svg",
      name: "Flask",
    },
    {
      image: "assets/images/html5.svg",
      name: "HTML",
    },
    {
      image: "assets/images/css3.svg",
      name: "CSS",
    },
    {
      image: "assets/images/javascript.svg",
      name: "JavaScript",
    },
  ],
  projects: [
    {
      id: 1,
      title: "DataMorph",
      link: "https://www.npmjs.com/package/@smv1999/datamorph",
      image:
        "https://github.com/smv1999/datamorph/blob/main/assets/datamorph.jpg?raw=true",
      description: {
        para1:
          "A package that allows you to convert your data between different formats.",
        para2:
          "The supported data formats include YAML, JSON, CSV and INI. The conversions that are supported include YAML to JSON, CSV to JSON, JSON to CSV, INI to JSON, JSON to INI.",
      },
    },
    {
      id: 2,
      title: "Sketch Tab - Your Art Playground",
      link: "https://play.google.com/store/apps/details?id=com.programmersgateway.sm1999.sketchtab",
      image:
        "https://play-lh.googleusercontent.com/arjwweu2ecu2V3OWozZUYYm67xWir-8njlyBtmayu33nhmZTFuBZ_E5ZkJe2-loNhg=w240-h480-rw",
      description: {
        para1:
          "Kick off the artist in you and get your hands to work on something cool. Play with the tools in the art gallery and enjoy drawing. It is completely offline.",
        para2:
          "The app is completely user-friendly and has a good user interface.",
      },
    },
    {
      id: 3,
      title: "Covid-19 Sahayak",
      link: "https://drive.google.com/file/d/189Xq2Gb28e5wd8Mja5F4-znbFo06U7K3/view",
      image:
        "https://raw.githubusercontent.com/smv1999/smv1999.github.io/master/coronavirus.png",
      description: {
        para1: "Provides live updates state-wise and at the world-level",
        para2:
          "Funds and helpline, Essentials and Maps are some unique features. The app has an Amazing UI/UX and comes with Dark mode in its very first version!",
      },
    },
    {
      id: 4,
      title: "Dev Portal - Community Portal for Developers",
      link: "https://play.google.com/store/apps/details?id=com.programmersgateway.sm1999.dev_portal",
      image:
        "https://play-lh.googleusercontent.com/4D3fo8kk8XYPV2kcVZKZdeL07hTxAFFuRKkAWRm7FLOT6TtNrCINKGB5uS7t_whbalZK=w240-h480-rw",
      description: {
        para1: "Dev Portal is a Community Portal for Developers.",
        para2:
          "It is an initiative to bring the developers across the world to connect with each other and it creates an environment for learning and growing together.",
      },
    },
    {
      id: 5,
      title: "pysh - A Cross-Platform Shell written in Python",
      link: "https://github.com/smv1999/pysh",
      image:
        "https://raw.githubusercontent.com/smv1999/pysh/refs/heads/main/assets/pysh.png",
      description: {
        para1:
          "pysh is a cross-platform shell written in Python. The shell consists of all the commands, from general to file management to networking.          ",
      },
    },
    {
      id: 6,
      title: "Custom Utility Header Files",
      link: "https://github.com/smv1999/custom-header-files-cpp",
      image: "assets/images/cplusplus.svg",
      description: {
        para1:
          "Custom Utility Header Files are created from scratch in C++ for performing various operations on Data Structures.",
        para2:
          "Additional functionalities are added for performing various operations on Arrays, Linked Lists and Trees.",
      },
    },
    {
      id: 7,
      title: "py_dsa",
      link: "https://pypi.org/project/py-dsa/",
      image:
        "https://github.com/smv1999/py_dsa/blob/main/assets/py_dsa.jpg?raw=true",
      description: {
        para1:
          "The py_dsa package contains all the data structures and algorithms implementations.",
      },
    },
  ],
  experiences: [
    {
      id: 1,
      company: "Tata Consultancy Services",
      positions: [
        {
          id: 1,
          position: "Systems Engineer",
          type: "Full Time",
          description: "Working on TCS MasterCraft",
          timeline: "May 2021 - Present",
        },
        {
          id: 2,
          position: "Project Intern",
          type: "Internship",
          description: "Worked in a Project named Smart Browser Console.",
          timeline: "Mar 2021 - May 2021",
        },
      ],
    },
    {
      id: 2,
      company: "GirlScript Foundation",
      positions: [
        {
          id: 1,
          position: "Technical Lead",
          type: "Internship",
          description:
            "Part Time - Worked in the field of Web Development and maintenance of the website",
          timeline: "May 2020 - Sep 2020",
        },
      ],
    },
    {
      id: 3,
      company: "SocialFriend Stressfree LLP",
      positions: [
        {
          id: 1,
          position: "Assistant Developer",
          type: "Internship",
          description:
            "Worked with Flask framework for creating their Web Platform. Built a robust Android App for creating their Mobile Platform. The application both in Mobile and Web version is a platform developed for school students which connects them with mentors and teachers",
          timeline: "Mar 2020 - June 2020",
        },
      ],
    },
    {
      id: 4,
      company: "Toshiba Machine (Chennai) Pvt Ltd",
      positions: [
        {
          id: 1,
          position: "Software Developer",
          type: "Internship",
          description:
            "Worked with Qt (C++) framework for creation of HMI for their manufacturing sector to monitor the working of their machines.",
          timeline: "Jun 2020 - Jul 2019",
        },
      ],
    },
  ],
};
